import { dataUrlToBlob } from '../utils/ImageUtils';

export default {
  methods: {
    getCanvas() {
      return this.$refs.canvas;
    },
    /**
     *
     * @return {Promise<void>}
     */
    async renderReady() {
      throw new Error('Not implemented');
    },
    /**
     *
     * @return {Promise<string>}
     */
    async toBase64() {
      await this.renderReady();

      const canvas = this.getCanvas();

      if (!canvas) {
        throw new Error('Canvas not found');
      } else if (!(canvas instanceof HTMLCanvasElement)) {
        throw new Error('Invalid canvas ref');
      }

      return canvas.toDataURL();
    },
    /**
     *
     * @return {Promise<Blob>}
     */
    async toBlob() {
      return dataUrlToBlob(await this.toBase64());
    },
  },
};
